<script>
import Str from "../../helpers/Str";

export const fieldTypeMap = {
  TEXT_FIELD: "App\\Models\\Forms\\FieldTypes\\TextField",
  TEXTAREA_FIELD: "App\\Models\\Forms\\FieldTypes\\TextareaField",
  SELECT_FIELD: "App\\Models\\Forms\\FieldTypes\\SelectField",
  CHECKBOX_FIELD: "App\\Models\\Forms\\FieldTypes\\CheckboxGroupField",
  RADIO_FIELD: "App\\Models\\Forms\\FieldTypes\\RadioGroupField",
  HTML_FIELD: "App\\Models\\Forms\\FieldTypes\\HtmlField",

  RATING_FIELD: "App\\Models\\Forms\\FieldTypes\\RatingField",
  NET_PROMOTER_FIELD: "App\\Models\\Forms\\FieldTypes\\NetPromoterField",

  CHECK_ALL_FIELD: "App\\Models\\Forms\\FieldTypes\\CheckAllField",
  MATCHING_FIELD: "App\\Models\\Forms\\FieldTypes\\MatchingField",
  MULTIPLE_CHOICE_FIELD: "App\\Models\\Forms\\FieldTypes\\MultipleChoiceField",
  SEQUENCE_FIELD: "App\\Models\\Forms\\FieldTypes\\SequenceField",
  TRUE_FALSE_FIELD: "App\\Models\\Forms\\FieldTypes\\TrueFalseField"
};

export const fieldModel = {
  id: Str.random(),
  type: fieldTypeMap.TEXT_FIELD,
  label: "",
  value: [""],
  autofill: null,
  is_required: false,
  is_conditional: false,
  conditional_visibility: 1,
  conditional_scope: 0,
  conditions: [{ ...conditionModel }],
  group_id: null
};

export const conditionModel = {
  target_id: null,
  operand: null,
  value: null
};

export default {
  props: {
    formType: { type: String, required: true },
    value: { type: Object, default: () => {} },
    currentFields: { type: Array, default: () => [] },
    fieldTypes: { type: Array, required: true },
    autoPopulateFields: { type: Array, required: true },
    conditional: { type: Object, required: true },
    fieldGroups: { type: Array, default: () => [] }
  },
  data() {
    return {
      field: { ...fieldModel }
    };
  },
  computed: {
    isHtmlField() {
      return this.field.type == fieldTypeMap.HTML_FIELD;
    },
    isForm() {
      return this.formType == "Form";
    },
    isSurvey() {
      return this.formType == "Survey";
    },
    fieldTypeLabel() {
      return this.fieldTypes.find(type => type.value == this.field.type).label;
    },
    hasOptions() {
      return [
        fieldTypeMap.SELECT_FIELD,
        fieldTypeMap.CHECKBOX_FIELD,
        fieldTypeMap.RADIO_FIELD
      ].includes(this.field.type);
    },
    canAutoPopulate() {
      return [fieldTypeMap.TEXT_FIELD, fieldTypeMap.TEXTAREA_FIELD].includes(
        this.field.type
      );
    },
    canBeRequired() {
      return ![fieldTypeMap.HTML_FIELD].includes(this.field.type);
    },
    conditionalTargets() {
      return this.currentFields
        .filter(field => {
          return field.id !== this.field.id && [
            fieldTypeMap.SELECT_FIELD,
            fieldTypeMap.CHECKBOX_FIELD,
            fieldTypeMap.RADIO_FIELD
          ].includes(field.type);
        })
        .map(field => {
          return { label: field.label, value: field.id };
        });
    }
  },
  watch: {
    value(val) {
      if (_.isObject(val) && !_.isEmpty(val)) {
        this.field = _.cloneDeep(val);
      }
    },
    "field.type": function(val) {
      if (_.isEmpty(this.value)) { 
            if (val === fieldTypeMap.HTML_FIELD) {
                this.field.value = "";
            } else {
                this.field.value = [""];
            }
      }
      if (_.has(this.field, "autofill")) {
        this.field.autofill = null;
      }
    },
    "field.is_conditional": function(val) {
      if (!val) {
        this.field.conditions = [{}];
      }
    }
  },
  methods: {
    addOption() {
      this.field.value.push("");
    },
    removeOption(index) {
      this.field.value.splice(index, 1);
    },
    conditionalValues(target_id) {
      var target = this.currentFields.find(field => field.id == target_id);
      if (!target) {
        return [];
      }
      var value = target.value;
      if (typeof value == "string") {
        value = JSON.parse(value) || [];
      }
      return value.map(v => {
        return { label: v, value: v };
      });
    },
    addCondition() {
      this.field.conditions.push({ ...conditionModel });
    },
    removeCondition(index) {
      this.field.conditions.splice(index, 1);
    },
    submit() {
      if (this.validate()) {
        this.$emit("submit", this.field);
        this.reset();
      }
    },
    reset() {
      this.field = { ...fieldModel };
      this.field.id = Str.random();
    },
    validate() {
      if (!this.field.label || !this.field.type) {
        alert(
          "Please enter a label and choose a field type before continuing."
        );
        return false;
      }
      if (this.hasOptions) {
        if (this.field.value.length == 0) {
          alert(
            "Please enter the values users will choose from for this field."
          );
          return false;
        }
        var filled = this.field.value.filter(v => !!v && v.length > 0);
        if (filled.length == 0) {
          alert(
            "Please enter the values users will choose from for this field."
          );
          return false;
        }
      }
      if (!!this.field.is_conditional) {
        if (this.field.conditions.length == 0) {
          alert("Please enter the criteria for the conditional logic.");
          return false;
        }
        var filled = this.field.conditions.filter(
          c => !!c.target_id && c.operand != null && c.value != null
        );
        if (filled.length == 0) {
          alert("Please enter the criteria for the conditional logic.");
          return false;
        }
      }
      return true;
    }
  }
};
</script>